import { Euler, Vector3 } from "three";
/** Computes the absolute start/end position of a route segment */
export function getStartEndPosition(node) {
    const absPosition = node.bakedRules.positionRelativeToDocument ?? { x: 0, y: 0, z: 0 };
    const absRotation = node.bakedRules.rotationRelativeToDocument ?? { x: 0, y: 0, z: 0 };
    const startOffset = node.bakedRules.startPosition ?? { x: 0, y: 0, z: 0 };
    const endOffset = node.bakedRules.endPosition ?? { x: 0, y: 0, z: 0 };
    const absPositionV3 = new Vector3(absPosition.x, absPosition.y, absPosition.z);
    const absRotationEuler = new Euler(absRotation.x, absRotation.y, absRotation.z);
    const startPosition = new Vector3(startOffset.x, startOffset.y, startOffset.z)
        .applyEuler(absRotationEuler)
        .add(absPositionV3);
    const endPosition = new Vector3(endOffset.x, endOffset.y, endOffset.z)
        .applyEuler(absRotationEuler)
        .add(absPositionV3);
    return [startPosition, endPosition];
}
//# sourceMappingURL=getStartEndPosition.js.map